import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { postData } from '../lib/utils';
import { toTitleCase } from '../lib/common';

function SignUp() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
      password: "",
  confirmPassword: "",
  });

  const navigate = useNavigate();

  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const companySize = ["Solo", "2-5", "5+"];
  const jobType = ["Video only", "Video + Photo(Hybrid)"];
  const numberOfClients = ["1-10", "11-50", "50+"];
  const projectSize = ["less than 10GB", "10-25GB", "25-50GB", "50GB+"];
  const typesOfMedia = [
    "Weddings & Life-Events",
    "Theatre Performances & Dance Recitals",
    "Commercial Projects",
    "Real Estate",
    "Educational Videos & Courses"
  ];
  const deliveryType = [
    "USB",
    "DVD/Blu-ray",
    "Vimeo",
    "Dropbox or Google Drive",
    "WeTransfer",
    "Mediazilla",
    "Eazyflicks",
    "Pixieset",
    "Other"
  ];
  const heardOption = [
    "Google Search",
    "Instagram",
    "Facebook",
    "Friend or Family",
    "YouTube",
    "Advertisement",
    "Other"
  ];

  useEffect(() => {
    localStorage.removeItem('token');
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      setFormData(prevData => ({
        ...prevData,
        [name]: checked
          ? [...prevData[name], value]
          : prevData[name].filter(val => val !== value),
      }));
    } else if (type === 'radio') {
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

 
  
  const verifyOtp = async () => {
  const response = await postData(
    "auth/verify-otp",
    {
      ...formData,
      otp
    }
    );
    console.log("rrrrrrrrr ",response)
    if (response.token) {
      localStorage.setItem("authToken", response.token);
    }
    if (response.success) {
    
      navigate("/studio/galleries");
    }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
      if (formData.password !== formData.confirmPassword) {
    alert("Passwords do not match");
    return;
  }

  if (formData.password.length < 6) {
    alert("Password must be at least 6 characters");
    return;
    }
    
    const response = await postData(
      "auth/send-otp",
      formData
    );

    if (response.success) {
      alert("OTP sent on your Email Id");
      setShowOtp(true);

    } else {
      alert(response.message);
    }
  };

  return (
<>
  {!showOtp ? (
    <section className="bg-gray-50 dark:bg-gray-900 overflow-auto h-screen">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto">
        <a className="mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          VidMantra
        </a>

        <div className="w-full text-left bg-white rounded-lg shadow dark:border sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-6">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Create your account
            </h1>

            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label className="block mb-2 text-sm font-medium">
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  className="w-full p-2.5 border rounded-lg"
                  required
                />
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="name@example.com"
                  className="w-full p-2.5 border rounded-lg"
                  required
                />
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium">
                  Mobile Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="9876543210"
                  maxLength={10}
                  className="w-full p-2.5 border rounded-lg"
                  required
                />
                  </div>
                  
                  <div>
  <label className="block mb-2 text-sm font-medium">
    Password
  </label>
  <input
    type="password"
    name="password"
    value={formData.password}
    onChange={handleChange}
    placeholder="Enter password"
    className="w-full p-2.5 border rounded-lg"
    required
  />
</div>

<div>
  <label className="block mb-2 text-sm font-medium">
    Confirm Password
  </label>
  <input
    type="password"
    name="confirmPassword"
    value={formData.confirmPassword}
    onChange={handleChange}
    placeholder="Confirm password"
    className="w-full p-2.5 border rounded-lg"
    required
  />
</div>

              <button
                type="submit"
                className="w-full text-white bg-gray-800 hover:bg-gray-700 font-medium rounded-lg text-sm px-5 py-2.5"
              >
                Sumbit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-5">

        <div className="text-center">
         

          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            Verify OTP
          </h2>

          <p className="text-sm text-gray-500 mt-2">
            OTP sent to
          </p>

          <p className="font-semibold text-blue-600">
            {formData.email}
          </p>
        </div>

        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          maxLength={6}
          placeholder="Enter OTP"
          className="w-full p-4 border rounded-lg text-center text-2xl tracking-[10px]"
        />

        <button
          type="button"
          onClick={verifyOtp}
          className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-semibold"
        >
          Verify OTP
        </button>

        <button
          type="button"
                onClick={() => { setOtp(""); setShowOtp(false) }}
          className="w-full border border-gray-300 py-3 rounded-lg"
        >
          Change Details
        </button>
      </div>
    </div>
  )}
</>
  );
}

export default SignUp;
